import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Modal from '@mui/material/Modal';
import MarkdownView from 'react-showdown';
import { JOB_DESCRIPTIONS } from "./JobDescriptions/en"
import CloseIcon from '@mui/icons-material/Close';

// Filter jobs that needs to show
const JOBS: any = JOB_DESCRIPTIONS.filter((el: any) => el.show === true);


// Job position box!
function JobBox(props: any) {
    return (
        <Box style={{
            width: "250px", height: "250px", padding: "10px", background: "url(blury_small.jpg)",
            backgroundSize: "contain", margin: 20, display: "flex", flexDirection: "column", alignItems: "center",
            boxShadow: "0px 0px 2px 2px #755a51"
        }}>

            <Box style={{ fontSize: 30, color: "white", fontWeight: 700, textAlign: "center", lineHeight: 1.2, padding: "0 10px" }}>{props.name}</Box>
            <Box style={{ fontSize: 25, color: "white", fontWeight: 400, textAlign: "center", lineHeight: 1.1, marginTop: 25 }}>Fully Remote</Box>

            <Box style={{ margin: "35px 0px 0px 0px" }}>
                <Button onClick={props.handleOpen} sx={{ background: "#f5eeee", fontWeight: 700, color: "#614037", "&:hover": { background: "white" } }} variant="contained">Details</Button>
            </Box>
        </Box>
    )
}

//job description modal
function JobModal(props: any) {

    // When job is null!
    let job: any = {};

    if (props.job) {
        job = props.job;
    }

    return (
        <Modal
            open={props.job !== null}
            onClose={props.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">

            <Box sx={{
                overflow: "hidden",
                position: 'absolute',
                top: "60px",
                left: 0,
                right: 0,
                marginLeft: "auto",
                marginRight: "auto",
                maxWidth: 1000,
                maxHeight: 800,
                padding: "20px",
                outline: "none",
                ['@media (max-height:600px)']: { top: "0px" }
            }}>
                <Box sx={{ background: "white", boxShadow: 10, borderRadius: "5px", overflow: "hidden" }}>
                    <Box style={{ borderBottom: "1px solid #c9c9c9", padding: "10px", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f3f3f3" }}>
                        <Box sx={{ marginLeft: "10px", fontWeight: 700, color: "#383838", fontSize: "17px", lineHeight: 1 }}>{job.name}</Box>
                        <CloseIcon onClick={props.handleClose} sx={{ cursor: 'pointer', color: "#555555", "&:hover": { color: "#777777" } }} />
                    </Box>

                    <Box sx={{
                        maxHeight: 550, overflow: "auto", wordWrap: "break-word", padding: "0px 20px 20px 20px",
                        ['@media (max-height:800px)']: { maxHeight: "450px" },
                        ['@media (max-height:700px)']: { maxHeight: "350px" },
                        ['@media (max-height:600px)']: { maxHeight: "330px" },
                        ['@media (max-height:500px)']: { maxHeight: "250px" },
                        ['@media (max-height:420px)']: { maxHeight: "200px" },
                    }}>

                        <MarkdownView
                            style={{ textAlign: "left", wordWrap: "break-word" }}
                            markdown={job.markdown}
                            options={{ tables: true, emoji: true }}
                        />
                    </Box>

                    <Box style={{ borderTop: "1px solid #c9c9c9", padding: 20, background: "#f3f3f3" }}>
                        <Button href={job.link} target="_blank"
                            sx={{ fontWeight: 700, background: "#6f5349", color: "white", "&:hover": { background: "#83665b" } }} variant="contained">Apply Now</Button>
                    </Box>
                </Box>
            </Box>

        </Modal>
    )
}

//
export function JoinUs(props: any) {
    const { t } = useTranslation();
    const theme = useTheme();

    // Used for modal with job description! Open modal when we have job!
    const [job, setJob] = React.useState<null | any>(null);

    const handleOpen = (job: string) => {
        setJob(job);
    };

    const handleClose = () => {
        setJob(null)
    };

    //
    return (
        <Box id="eternal-dragons-joinus" className={props.className} style={{ padding: 20, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginBottom: "40px" }}>

            <Box style={{ maxWidth: 800, color: "#181f27", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <Box>
                    <img src="Ornament_SectionBreakTwistedDragons.png" alt="team members top ornament" style={{ maxWidth: "800px", width: "100%", padding: "20px" }} />
                </Box>

                <Box style={{ fontWeight: 700, fontSize: 40, paddingBottom: 20 }}>JOIN US</Box>

                <Box style={{ color: "#555555", fontSize: "16px", maxWidth: "600px", marginBottom: "20px" }}>
                    Trailblazer Games is on a mission to lead the biggest transformational wave ever seen in gaming.
                    Do you, like us, believe that blockchain will bring new experiences never before seen or imagined to players? <br />
                    We&apos;re a fully distributed team, so you can <strong>work from anywhere</strong> in the world or the metaverse!
                    <br /><br />

                    Apply to: <a target="_blank" rel="noreferrer" href="mailto:jobs@trailblazer.games" style={{ color: "#344bc1", textDecoration: "underline" }}>jobs@trailblazer.games</a>
                </Box>

                <Box style={{ display: "flex", maxWidth: "700px", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
                    {
                        JOBS.map((j: any) => {
                            return (<JobBox key={j.id} name={j.name} handleOpen={() => handleOpen(j)} />);
                        })
                    }
                </Box>
            </Box>

            {/* Modal */}
            <JobModal job={job} handleClose={handleClose} />
        </Box >
    );
}


// Default style!
const JoinUsStyled = styled(JoinUs)({

});


export default JoinUsStyled;